export default function Boolean(params) {
  const booleanCell = document.createElement('div');
  booleanCell.classList.add('w5-text-cell');
  let value = false;
  if (typeof params.value === 'boolean') value = params.value;
  if (['True', '1', 'true', 1].includes(params.value)) value = true;
  booleanCell.innerText = value ? params.context.t('common_yes') : params.context.t('common_no');
  return booleanCell;
}